import React from "react";
import styled from "@emotion/styled";
import useAuth from "../../hooks/useAuth";

import { Alert as MuiAlert } from "@mui/material";
import { spacing } from "@mui/system";

import Default from "../dashboards/Default";

const Alert = styled(MuiAlert)(spacing);

function ProtectedPage() {
  const { user } = useAuth();
  return (
    <React.Fragment>
      <Default />
    </React.Fragment>
  );
}

export default ProtectedPage;
